import { id as gfaServiceConfigProviderId, } from "@volkswagen-onehub/gfa-service-config-provider";
import { createObservable } from "./create-observable";
export function defineServiceConfigProvider(initialConfig, options) {
    return {
        id: "service-config-provider",
        create: () => {
            const { configs } = initialConfig;
            const configProvider = {
                configs,
            };
            return {
                "1.1.0": (consumerId, consumerName) => {
                    const accessListener = options && options.onAccess
                        ? (key) => {
                            if (options.onAccess) {
                                options.onAccess(consumerId, consumerName, key);
                            }
                        }
                        : undefined;
                    return accessListener
                        ? {
                            featureService: createObservable(configProvider, accessListener),
                        }
                        : {
                            featureService: configProvider,
                        };
                },
            };
        },
    };
}
export function defineGfaServiceConfigProvider(gfaServiceConfig) {
    return {
        id: gfaServiceConfigProviderId,
        create: () => {
            const configProvider = gfaServiceConfig;
            return {
                "1.0.0": () => ({
                    featureService: configProvider,
                }),
            };
        },
    };
}
